<div>
  <p nz-typography nzType="danger">
    Bạn có muốn xóa?
  </p>
</div>
<div *nzModalFooter>
  <button nz-button (click)="close($event)">Đóng</button>
  <button nz-button nzType="danger">Xóa</button>
</div>
